"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isMigration = exports.isIdentify = exports.isCustom = exports.isFeature = void 0;
function isFeature(u) {
    return u.kind === 'feature';
}
exports.isFeature = isFeature;
function isCustom(u) {
    return u.kind === 'custom';
}
exports.isCustom = isCustom;
function isIdentify(u) {
    return u.kind === 'identify';
}
exports.isIdentify = isIdentify;
function isMigration(u) {
    return u.kind === 'migration_op';
}
exports.isMigration = isMigration;
//# sourceMappingURL=guards.js.map